export enum MenuIcon {
  outlined = 'material-icons-outlined',
  filled = 'material-icons',
  sharp = 'material-icons-sharp',
  rounded = 'material-icons-round',
  twoTones = 'material-icons-two-tones',
  none = 'none',
}
